import React, { useRef, useState } from "react";
import logo from "./logo.png";
export default function Header() {
  const [open, setOpen] = useState(false);
  const toggle = useRef(null);
  function closeOnEscape(event) {
    if (event.key === "Escape" && open) {
      setOpen(false);
      toggle.current.focus();
    }
  }
  return (
    <header className="site-header" onKeyDown={closeOnEscape}>
      <div className="container header-inner">
        <a href="/" className="brand" aria-label="Quantingo home">
          <img
            src={logo}
            alt="Quantingo Software Solutions"
            width="704"
            height="203"
          />
        </a>
        <button
          ref={toggle}
          className="menu-toggle"
          aria-expanded={open}
          aria-controls="primary-navigation"
          onClick={() => setOpen(!open)}
        >
          {open ? "Close" : "Menu"}{" "}
          <span aria-hidden="true">{open ? "×" : "+"}</span>
        </button>
        <nav
          id="primary-navigation"
          className={open ? "navigation is-open" : "navigation"}
          aria-label="Main navigation"
        >
          {[
            ["Services", "/services"],
            ["Work", "/#work"],
            ["How We Work", "/how-we-work"],
            ["Partners", "/partners"],
            ["Contact", "/contact"],
          ].map(([item, href]) => (
            <a key={item} href={href} onClick={() => setOpen(false)}>
              {item}
              {item === "Contact" && <span aria-hidden="true"> ↗</span>}
            </a>
          ))}
        </nav>
      </div>
    </header>
  );
}
